import React from "react";
import logo from "../assets/logo.svg";

const Logo = () => {
  return (
    <>
      <img src={logo} alt="FsuhLogo" className="logo" />
    </>
  );
};

export default Logo;
